<template>
  <div class="referral-submit-page" :style="customStyle">
    <ResumeEditor
      :resumeEditorSetting="resumeEditorSetting"
      :hiddenSteps="hiddenSteps"
      :isReferral="true"
      :showUploadButton="false"
      :customPageInfo="customPageInfo"
    />
  </div>
</template>

<script>
import _ from 'lodash'
import { mapActions, mapGetters } from 'vuex'
import { STEP_TYPE } from '@/constant/candidate'
import { mixedRouterPush } from '@/router/routes'
import ResumeEditor from '@/components/candidate/mobile/layout.vue'

const REFERRAL_NEED_UPLOAD_RESUME_COMPANY_IDS = [64, 8190, 6426, 8491, 6143]

export default {
  components: {
    ResumeEditor
  },
  data () {
    return {
      hiddenSteps: [STEP_TYPE.UPLOAD_RESUME, STEP_TYPE.BASE_INFO, STEP_TYPE.EDUCATION, STEP_TYPE.WORK_EXPERIENCE, STEP_TYPE.LANGUAGE, STEP_TYPE.ADDITIONAL_INFO, STEP_TYPE.RESUME_INFO, STEP_TYPE.JOB_QUESTIONNAIRE, STEP_TYPE.INVITE_QUESTIONNAIRE],
      resumeEditorSetting: {
        [STEP_TYPE.SUBMIT_REFERRAL]: {
          needUploadResume: false,
          noNeedReason: false
        }
      },
      customStyle: null,
      customPageInfo: {}
    }
  },
  computed: {
    jobId () {
      return this.$route.query?.job_id
    },
    companyId () {
      const companyId = this.$route.query?.company_id
      return companyId && _.toNumber(companyId)
    }
  },
  async created () {
    if (this.companyId) {
      this.resumeEditorSetting[STEP_TYPE.SUBMIT_REFERRAL].needUploadResume = REFERRAL_NEED_UPLOAD_RESUME_COMPANY_IDS.includes(this.companyId)
      this.resumeEditorSetting[STEP_TYPE.SUBMIT_REFERRAL].noNeedReason = this.companyId === 6143
      if (this.jobId) {
        this.loadCompanyInfo()
      }
    }
  },
  mounted () {
  },
  methods: {
    ...mapGetters('account', ['getCurrentAccount']),
    ...mapActions('application', ['getJobApplyRequiredInfo']),
    ...mapActions('company', ['getCompanyBaseInfo', 'getCustomJobListPageInfo']),
    async handleCancel () {
      let backUrl = this.$route.query.back
      backUrl = _.replace(backUrl, 'go_to_submit=1', 'go_to_submit=0')
      if (backUrl) {
        mixedRouterPush(backUrl)
      } else if (this.jobId) {
        this.$router.push(`/job-detail-new/${this.jobId}/c/`)
      } else {
        this.$router.push({ path: '/recruiting/personal/home', query: { company_id: this.companyId } })
      }
    },
    async loadCustomJobListPageInfo () {
      if (this.companyId) {
        const resp = await this.getCustomJobListPageInfo({ company_id: this.companyId })
        if (resp) {
          this.customPageInfo = resp
        }
      }
    },
    async loadCompanyInfo () {
      if (this.companyId && this.jobId) {
        const resp = await this.getCompanyBaseInfo({ id: this.companyId })
        if (resp && resp.custom_color) {
          this.customStyle = {
            '--custom-color': resp.custom_color
          }
        }
      }
    }
  }
}
</script>

<style>

</style>
